import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import { StatusBadge } from "@/components/StatusBadge";
import { StatusTimeline } from "@/components/StatusTimeline";

export const ReferralInfo = ({ r }) => (
  <dl className="grid gap-4 text-sm sm:grid-cols-2" data-testid="referral-info">
    {[
      ["Persona", r.lead_name], ["Città", r.lead_city], ["Telefono", r.lead_phone || "-"], ["Email", r.lead_email || "-"],
      ["Tipologia", `${r.category_name}${r.category_source === "ai" ? " (suggerita AI)" : r.category_source === "admin" ? " (corretta da admin)" : ""}`],
      ["Inviata il", fmtDateTime(r.created_at)],
    ].map(([k, v]) => (
      <div key={k}>
        <dt className="text-xs uppercase tracking-wider text-[#75867E]">{k}</dt>
        <dd className="mt-0.5 break-words font-medium">{v}</dd>
      </div>
    ))}
    <div className="sm:col-span-2">
      <dt className="text-xs uppercase tracking-wider text-[#75867E]">Esigenza</dt>
      <dd className="mt-0.5 whitespace-pre-wrap">{r.need}</dd>
    </div>
  </dl>
);

export default function ReferralDetail() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get(`/referrals/${id}`).then((x) => setR(x.data)).catch((e) => setError(errMsg(e)));
  }, [id]);

  return (
    <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6" data-testid="referral-detail-page">
      <Link to="/dashboard" className="inline-flex h-11 items-center gap-2 text-sm font-medium text-[#0F2D5E]" data-testid="back-dashboard-link">
        <ArrowLeft className="h-4 w-4" /> Le mie segnalazioni
      </Link>
      {error && <p className="mt-6 text-red-700" data-testid="referral-detail-error">{error}</p>}
      {!r && !error && <Loader2 className="mt-10 h-6 w-6 animate-spin text-[#0F2D5E]" />}
      {r && (
        <div className="rise mt-4 space-y-6">
          <div className="flex flex-wrap items-center gap-3">
            <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">{r.lead_name}</h1>
            <StatusBadge status={r.status} testId="referral-detail-status" />
          </div>
          <section className="rounded-3xl border border-[#E2E5DC] bg-white p-5 sm:p-7"><ReferralInfo r={r} /></section>
          <section className="rounded-3xl border border-[#E2E5DC] bg-white p-5 sm:p-7">
            <h2 className="mb-5 text-lg font-bold">Storico stati</h2>
            <StatusTimeline history={r.history} />
          </section>
        </div>
      )}
    </main>
  );
}
